import { SalesItemBookingCategoryType, SalesItemForBookingRecord } from '@navio/nsdk';
import { CarWithSalesItemsForNewBooking, SALES_ITEM_BOOKING_FLOW_TYPE } from 'noddi-types';
import { cn } from 'noddi-ui-common';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from 'noddi-ui-web';
import { useState } from 'react';
import { getPriceFormatted } from '../../../../utils/translation';
import { SalesItem } from './SalesItem';
import { SalesItemContainer, SalesItemWrapper } from './SalesItemWrapper';
import { ServiceCategoryHeader } from './ServiceCategoryHeader';

type ServiceCategoryCollapseCardProps = {
  numberOfSelectedSalesItems: number;
  salesItems: SalesItemForBookingRecord[];
  licensePlate: CarWithSalesItemsForNewBooking['licensePlate'];
  bookingCategoryType: SalesItemBookingCategoryType;
  salesItemType: SALES_ITEM_BOOKING_FLOW_TYPE;
  mountAsExpanded?: boolean;
};

export const ServiceCategoryCollapseCard = ({
  numberOfSelectedSalesItems,
  salesItemType,
  bookingCategoryType,
  salesItems,
  licensePlate,
  mountAsExpanded
}: ServiceCategoryCollapseCardProps) => {
  const [isExpanded, setIsExpanded] = useState(!!mountAsExpanded);

  const priceFormDescription = getPriceFormatted(salesItems);

  return (
    <Accordion
      value={isExpanded ? [bookingCategoryType] : []}
      onValueChange={(value) => setIsExpanded(value.includes(bookingCategoryType))}
      className='rounded-xl border bg-card transition-shadow hover:shadow-md'
    >
      <AccordionItem value={bookingCategoryType}>
        <AccordionTrigger headingLevel={2} hideChevron className={cn('p-0 font-normal hover:no-underline')}>
          <ServiceCategoryHeader
            numberOfSelectedSalesItems={numberOfSelectedSalesItems}
            priceFrom={priceFormDescription}
            bookingCategoryType={bookingCategoryType}
            isExpanded={isExpanded}
          />
        </AccordionTrigger>
        <AccordionContent className='p-0'>
          <SalesItemContainer>
            {salesItems.map((item) => (
              <SalesItemWrapper key={item.salesItemId}>
                <SalesItem
                  className='border-none px-4 py-3 shadow-none! sm:p-5'
                  type={salesItemType}
                  licensePlate={licensePlate}
                  salesItem={item}
                />
              </SalesItemWrapper>
            ))}
          </SalesItemContainer>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
